import { useI18n } from '@/hooks/useI18n.ts';

export function getSmsErrorMessage(error: any, fallbackMessage: string): string {
    const { t, te } = useI18n();
    const backendCode = error?.response?.data?.error?.code;

    if (backendCode) {
        const translationKey = `smsCommunication.errors.${backendCode}`;

        if (te(translationKey)) {
            return t(translationKey);
        }
    }

    return fallbackMessage;
}
